jQuery(function ($) {
  var cartMotivator = {
    view: {
      progressBar: function () {
        console.log("cart motivator init");
      },

      processCartUpdates: function (data) {

        let totalPrice = data.original_total_price / 100;
        let cmDom = $(document).find('.ast-cart-motivator');
        let loadingBar = cmDom.find('.bar-loading');
        let tierLabel = '';
        let tierSpendPrice = 0;
        let tier3TotalPrice = cmDom.find('.cm-tier-3').length > 0 ? cmDom.find('.cm-tier-3').attr('data-total') : 0;
        let tier4TotalPrice = cmDom.find('.cm-tier-4').length > 0 ? cmDom.find('.cm-tier-4').attr('data-total') : 0;

        cmDom.find('.cm-c-check').css('background-color', '#fff');

        const getNumberOfFilledTiers = () => {
          let count = 0;
          for (let i=0; i<4; i++) {
            if (cmDom.find(`.cm-tier-${i+1}`).length > 0) {
              count++;
            }
          }

          return count;
        };
        
        const numberOfFilledTiers = getNumberOfFilledTiers();
        const sliceWidth = 100 / numberOfFilledTiers;
        const centerOfSlice = Math.floor(sliceWidth / 2);

        const makeProgressFull = () => {
          loadingBar.css('width', '100%');
        };

        if(totalPrice > 0 && totalPrice < parseFloat(cmDom.find('.cm-tier-1').attr('data-total'))) {
            loadingBar.css('width', `${Math.floor(centerOfSlice / 2)}%`);
            tierLabel = cmDom.find('.cm-tier-1').attr('data-label');
            tierSpendPrice = parseFloat(cmDom.find('.cm-tier-1').attr('data-total')) - totalPrice;

            if(numberOfFilledTiers == 1) {
              makeProgressFull();
            }

        } else if(totalPrice > parseFloat(cmDom.find('.cm-tier-1').attr('data-total')) && totalPrice < parseFloat(cmDom.find('.cm-tier-2').attr('data-total'))) {           
            loadingBar.css('width', `${centerOfSlice}%`);
            cmDom.find('.cm-tier-1 .cm-c-check').css('background-color', '#ffcfbe');
            tierLabel = cmDom.find('.cm-tier-2').attr('data-label');
            tierSpendPrice = parseFloat(cmDom.find('.cm-tier-2').attr('data-total')) - totalPrice;

            if(numberOfFilledTiers == 1) {
              makeProgressFull();
            }

        } else if((totalPrice > parseFloat(cmDom.find('.cm-tier-2').attr('data-total')) && totalPrice < parseFloat(tier3TotalPrice)) || (totalPrice >= parseFloat(cmDom.find('.cm-tier-2').attr('data-total')) && tier3TotalPrice == 0)) {
            loadingBar.css('width', `${centerOfSlice * 3}%`);
            cmDom.find('.cm-tier-1 .cm-c-check').css('background-color', '#ffcfbe');
            cmDom.find('.cm-tier-2 .cm-c-check').css('background-color', '#ffcfbe');
            tierLabel = cmDom.find('.cm-tier-3').attr('data-label');
            tierSpendPrice = parseFloat(cmDom.find('.cm-tier-3').attr('data-total')) - totalPrice;

            if(numberOfFilledTiers == 2) {
              makeProgressFull();
            }

        }  else if((totalPrice > parseFloat(cmDom.find('.cm-tier-3').attr('data-total')) && totalPrice < parseFloat(tier4TotalPrice)) || (totalPrice >= parseFloat(cmDom.find('.cm-tier-3').attr('data-total')) && tier4TotalPrice == 0)) {
          loadingBar.css('width', `${centerOfSlice * 5}%`);
          cmDom.find('.cm-tier-1 .cm-c-check').css('background-color', '#ffcfbe');
          cmDom.find('.cm-tier-2 .cm-c-check').css('background-color', '#ffcfbe');
          cmDom.find('.cm-tier-3 .cm-c-check').css('background-color', '#ffcfbe');
          tierLabel = cmDom.find('.cm-tier-4').attr('data-label');
          tierSpendPrice = parseFloat(cmDom.find('.cm-tier-4').attr('data-total')) - totalPrice;

          if (numberOfFilledTiers == 3) {
            makeProgressFull();
          }

      } else if(totalPrice >= parseFloat(cmDom.find('.cm-tier-4').attr('data-total'))) {
            makeProgressFull();
            cmDom.find('.cm-c-check').css('background-color', '#ffcfbe');
            cmDom.find('.cm-message').text('Congratulations, you get ' + cmDom.find('.cm-tier-4').attr('data-label') + '!')
        }
        
        if(totalPrice == 0) {
            loadingBar.css('width', '0%');
        }

        if(totalPrice < parseFloat(cmDom.find('.cm-tier-4').attr('data-total'))) {
            cmDom.find('.cm-message').text('Spend $' + tierSpendPrice.toFixed(2) + ' extra to get ' + tierLabel + '!');
        }
        
      },

      listenToCartUpdates: function () {
        // Listeners for product added and cart updates
        ["cart:updated", "ajaxProduct:added"].forEach((evt) =>
          document.addEventListener(evt, cartMotivator.view.getCartData, false)
        );
      },

      getCartData: function () {
        fetch(
          window.theme.routes.cart ? window.theme.routes.cart : "/cart.js",
          {
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
          }
        )
          .then((response) => response.json())
          .then(cartMotivator.view.processCartUpdates);
      },

      init: function () {
        this.listenToCartUpdates();
        this.progressBar();
      },
    },
  };

  $(document).ready(function () {
    cartMotivator.view.init();
  });
});
